/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RawSubscriptionV4Response } from './rawSubscriptionV4Response';


export interface RawSubscriptionV4PaginatedResponse { 
    current_page_size?: number;
    raw_subscriptions_v4?: Array<RawSubscriptionV4Response>;
    requested_page_number?: number;
    requested_page_size?: number;
    total_pages?: number;
    total_record_count?: number;
}

